export default __webpack_public_path__ + "maps-examples-constraining-gestures-thumbnail-960-4fa4e620795f8c5efa843b90073ff327.png";